import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { RestartDialogComponent } from "../restart-dialog/restart-dialog.component";
import { QuestionnaireService } from "../services/questionnaire.service";
import { Router, NavigationEnd } from '@angular/router';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { LeadService } from "../services/lead.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  showContactUs: boolean;
  modalRef;
  constructor(
    private questionnaireService: QuestionnaireService, 
    private router: Router,
    private modalService: NgbModal,
    private leadService: LeadService) {

      router.events
			.filter(event => event instanceof NavigationEnd)
			.subscribe((event:any) => {
        let path = event.url.split("/");
        
			  this.showContactUs = (path[path.length-1] !== "end");
			});
    }

  ngOnInit() {
  }
  restartClick() {
    console.log(">>> restartClick()");
    this.questionnaireService.openTermsOfUse =true;
    let isAdvisor = this.questionnaireService.getIsAdvisor();
		this.modalRef = this.modalService.open(RestartDialogComponent).result.then((result) => {
          this.leadService.resetGuid();
          if(isAdvisor){
            this.router.navigate(["questionnaire", "advisors", "1"]);
            this.questionnaireService.reset("0");
          }
          else{
          this.router.navigate(["questionnaire", "user-details", "1"]);
          this.questionnaireService.reset("1");
          }
          this.questionnaireService.openTermsOfUse =false;
			},error=>{
        console.log("close");
        this.questionnaireService.openTermsOfUse =false;
      }
		);
  }
  openHelpDialog() {
    this.modalRef = this.modalService.open(HelpDialogComponent);
    // .result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts